import {
  CustomersSubscriptionApiModel,
  CustomersSubscriptionApiResponseModel,
  CustomersSubscriptionModel,
} from './customersSubscription.model';

export const customersSubscriptionAdapter = (
  subscription: CustomersSubscriptionApiModel
): CustomersSubscriptionModel => ({
  id: subscription.id,
  contractId: subscription.contract_id,
  expiredAt: subscription.subscribe_before,
  subscriptionTemplate: {
    id: subscription.id,
    type: subscription.subscription_template.type,
    title: subscription.subscription_template.title,
    slug: subscription.subscription_template.slug,
  },
});

export const customersSubscriptionResponseAdapter = ({
  data,
}: CustomersSubscriptionApiResponseModel): CustomersSubscriptionModel[] =>
  data.order_subscriptions.map(customersSubscriptionAdapter);
